import React, { useEffect } from "react";
import {
  FaBell,
  FaCommentAlt,
  FaHeart,
  FaShare,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";
import pipaanlogo from "../../assets/pipaanlogo.png";
import groupimg from "../../assets/groupimg.png";
import userimg from "../../assets/user.png";
import profileimg from "../../assets/profile.png";
import share from "../../assets/share.png";
import newsfeed from "../../assets/images/icons/newsfeed.svg";
import calendar from "../../assets/images/icons/calendar.png";
import location from "../../assets/images/icons/location.png";
import editcover from "../../assets/images/icons/edit-2.png";
import { MoreHorizontal } from "lucide-react";
import edit from "../../assets/images/icons/edit.png";
import mobile from "../../assets/images/icons/mobile.png";
import house from "../../assets/images/icons/house.png";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../../assets/images/icons/groupandfamily.png";
import chats from "../../assets/images/icons/chats.png";
import profile from "../../assets/images/icons/profile.png";
import camera from "../../assets/images/icons/camera.png";
import locationicon from "../../assets/images/icons/location.png";
import mobileicon from "../../assets/images/icons/mobile.png";
import Account from "../../assets/images/icons/account-setting.png";
import help from "../../assets/images/icons/helpandsupport.png";
import logout from "../../assets/images/icons/logout.svg";
import notification from "../../assets/images/icons/notification.png";
import gallery from "../../assets/images/icons/gallery.svg";
import video from "../../assets/images/icons/video.svg";
import taguser from "../../assets/images/icons/tag-user.svg";
import send from "../../assets/images/icons/send.svg";
import global from "../../assets/images/icons/global.svg";
import hamburger from "../../assets/images/icons/hamburger.png";
import hamburgerclose from "../../assets/images/icons/hamburgerclose.png";
import closecircle from "../../assets/images/icons/close-circle.png";
import FeedPost from "../feedpost/FeedPost";
import profileData from "../feedpost/profiledata";
import { Menu, X, Bell, User, Home, Edit } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import profilebanner from "../../assets/images/Profile-banner.png";
import Add from "../../assets/images/icons/add-circle.png";
import Danger from "../../assets/images/icons/danger.png";
import Attach from "../../assets/images/icons/link.png";
import Trash from "../../assets/images/icons/trash.png";
import axios from "axios";
import Editicon from "../../assets/images/icons/edit.png";
import { friendRequests, groupData } from "../nestedtab/friendRequestsData";
import { useRef } from "react";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Adminpanel = ({
  matchedGroup,
  onGroupDelete,
  setShowDashboard,
  setActiveTab,
}) => {
  const [isOpen, setIsOpen] = useState(false); // << move useState at the top
  const [isEditingGroup, setIsEditingGroup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const groupId = 39; // You can dynamically set this if needed
  const [followers, setFollowers] = useState([]);
  const [groupMembers, setGroupMembers] = useState(matchedGroup?.members || []);
  const [uploading, setUploading] = useState(false);
  const [memberSearch, setMemberSearch] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const searchTimeout = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [groupData, setGroupData] = useState([]); // Store groups from API
  const [loading, setLoading] = useState(false); // Loading state for the API call
  const [hasMore, setHasMore] = useState(true); // To check if more data is available
  const [error, setError] = useState(null); // Error state for file upload
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [modalSearch, setModalSearch] = useState("");
  const [modalResults, setModalResults] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportReason, setReportReason] = useState("");

  const reportReasons = [
    "Spam",
    "Inappropriate Content",
    "Harassment",
    "Fake Group",
    "Other",
  ];
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const res = await axios.get(
        `${API_BASE_URL}/user/profile`,
        {
          headers: { token },
        }
      );
      if (res.data.success) setCurrentUser(res.data.result);
    };

    fetchProfile();
  }, []);

  const handleLeaveGroup = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to leave the group?"
    );
    if (!confirmed) return;

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await fetch(
        `${API_BASE_URL}/group_member/delete-group_member-by-userid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_id: matchedGroup.id, // or groupId, if that's what you're using
            user_id: currentUser.id, // use current logged-in user's ID
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("You have successfully left the group.");
        window.location.reload();
        // Optionally: redirect, refresh members, or update UI
        fetchGroupMembers(); // or navigate away
      } else {
        alert("Failed to leave group: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error while leaving the group: " + error.message);
    }
  };

  const handleModalSearch = async (e) => {
    const value = e.target.value;
    setModalSearch(value);

    if (!value.trim()) {
      setModalResults([]);
      return;
    }

    setModalLoading(true);
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const response = await axios.post(
        `${API_BASE_URL}/user/get-all-users`,
        {
          filters: {
            isFriendsOnly: true,
            search: value,
          },
          page: 1,
          limit: 10,
        },
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        setModalResults(response.data.result.users || []);
      } else {
        setModalResults([]);
      }
    } catch (error) {
      setModalResults([]);
    }
    setModalLoading(false);
  };
  // Add this function inside your component
  const handleMemberSearch = (e) => {
    const value = e.target.value;
    setMemberSearch(value);

    // Debounce API call
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      fetchGroupMembers(value);
    }, 400);
  };
  const handleMakeAdmin = async (member) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/group_member/edit-group_member`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_member_id: member.id,
            user_id: member.user.id,
            role: "admin",
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("Member promoted to admin!");
        fetchGroupMembers(); // Refresh the member list
      } else {
        alert("Failed to make admin: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error making admin: " + error.message);
    }
  };
  const handleRemoveMember = async (member) => {
    const confirmed = window.confirm(
      "Are you sure you want to remove this member?"
    );
    if (!confirmed) return;

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await fetch(
        `${API_BASE_URL}/group_member/delete-group_member-by-userid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_id: matchedGroup.id,
            user_id: member.user.id,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("Member removed!");
        fetchGroupMembers();
        setGroupMembers(data.result);

        // ✅ Navigate back to chat view
        setActiveTab("Groupchat");
        setShowDashboard(true);
      } else {
        alert("Failed to remove member: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error removing member: " + error.message);
    }
  };

  const handleUnfollow = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const userId = sessionStorage.getItem("userID"); // Make sure you store userID in sessionStorage on login
    try {
      const response = await fetch(
        `${API_BASE_URL}/group_member/delete-group_member-by-userid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_id: matchedGroup.id,
            user_id: userId,
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("You have unfollowed/left the group!");
        fetchGroupMembers(); // Optionally refresh the member list
      } else {
        alert("Failed to unfollow: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error unfollowing: " + error.message);
    }
  };
  const fetchGroupMembers = async (searchValue = "") => {
    setSearchLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/group_member/get-group_members`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: {
              search: searchValue,
              group_id: String(matchedGroup.id), // Pass group_id as string
            },
            page: 1,
            limit: 10,
            // group_id: matchedGroup.id, // Make sure to send group_id if required by your API
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        setGroupMembers(data.result.group_members || []);
        return data.result.group_members;
      } else {
        setGroupMembers([]);
      }
    } catch (error) {
      setGroupMembers([]);
    }
    setSearchLoading(false);
  };

  // Optionally, fetch all members on mount
  useEffect(() => {
    fetchGroupMembers();
  }, [matchedGroup?.id]);

  // Fetch followers (on modal open)
  useEffect(() => {
    if (showModal) {
      fetchFollowers();
    }
  }, [showModal]);

  const fetchFollowers = async (query = "", page = 1) => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    const requestBody = {
      filters: {
        isFriendsOnly: true,

        // search: query, // Add search query to filter results
      },
      page: page,
      limit: 10,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/user/get-all-users`,
        requestBody,
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const newFollowers = response.data.result.users;

        // Append new followers to the existing list
        setFollowers((prev) =>
          page === 1 ? newFollowers : [...prev, ...newFollowers]
        );

        // Check if there are more followers to load
        if (newFollowers.length < 10) {
          setHasMore(false); // No more data if fewer than 10 items are returned
        }
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  // 2. Move fetchGroups outside useEffect so you can call it manually
  const fetchGroups = async (search = "") => {
    setLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const userId = sessionStorage.getItem("userID"); // Make sure userID is stored in sessionStorage

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/get-groups`,
        {
          filters: {
            myAcceptedGroup: true,
            search: search, // Add search key here
          },
          page: 1,
          limit: 50,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
        }
      );
      if (response.data.success) {
        // Filter out deleted groups
        const filteredGroups = response.data.result.groups.filter(
          (group) => !group.is_deleted
        );
        setGroupData(filteredGroups);
      } else {
        console.error("Failed to fetch groups:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddMember = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!selectedUserId || !token) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group_member/add-group_member`,
        {
          group_id: String(matchedGroup.id), // Ensure group_id is a string
          user_id: String(selectedUserId), // Send as string for safety
          role: "member",
        },
        {
          headers: { token },
        }
      );
      if (response.data && response.data.success) {
        alert("Member added!");
        setShowModal(false);
        setSelectedUserId(null);
        // Fetch updated members list
        fetchGroupById(matchedGroup.id);
      } else {
        alert(
          "Failed to add member: " + (response.data?.message || "Unknown error")
        );
      }
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
  };

  const fetchGroupById = async (groupId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await axios.get(
        `${API_BASE_URL}/group/get-group-by-id?id=${groupId}`,
        {
          headers: { token },
        }
      );
      if (response.data.success) {
        setGroupMembers(response.data.result.members || []);
      } else {
        setGroupMembers([]);
        console.error("Failed to fetch group members:", response.data.message);
      }
    } catch (error) {
      setGroupMembers([]);
      console.error("Error fetching group members:", error);
    }
  };

  const [editedGroup, setEditedGroup] = useState({
    group_name: "",
    description: "",
    group_image: "",
    group_cover: "",
  });

  useEffect(() => {
    if (matchedGroup) {
      setEditedGroup({
        group_name: matchedGroup.group_name || "",
        description: matchedGroup.description || "",
        group_image: matchedGroup.group_image || "",
        group_cover: matchedGroup.group_cover || "",
      });
    }
  }, [matchedGroup]);

  if (!matchedGroup) {
    return <p className="text-red-500 text-center">No matching group found!</p>;
  }

  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleGroupUpdate = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const requestBody = {
      group_id: matchedGroup.id,
      group_name: editedGroup.group_name,
      description: editedGroup.description,
      group_image: editedGroup.group_image, // you can hook this to an upload field
      group_cover: editedGroup.group_cover,
      is_deleted: false,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/group/edit-group`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Group updated successfully");
        setIsEditingGroup(false);
        window.location.reload(); // Refresh the page to see changes
        // Optional: refresh page or update matchedGroup locally
      } else {
        alert("Failed to update group: " + result.message);
      }
    } catch (error) {
      console.error("Error updating group:", error);
      alert("An error occurred while updating the group.");
    }
  };

  // 1. Place this uploadFiles function at the top (or import it if shared)
  const uploadFiles = async (uploadedMedia) => {
    if (uploadedMedia.length === 0)
      throw new Error("No files selected for upload");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              "Content-Type": uploadedMedia[index].file.type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      // Return the uploaded media URLs
      return preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl,
      }));
    } catch (error) {
      console.error("Upload error:", error);
      throw new Error("Failed to upload files. Please try again.");
    }
  };

  // 2. Add these handlers inside your Adminpanel component:

  const handleGroupImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const uploaded = await uploadFiles([{ file }]);
      setEditedGroup((prev) => ({ ...prev, group_image: uploaded[0].url }));
    } catch (err) {
      alert("Failed to upload group image.");
    }
    setUploading(false);
  };

  const handleDeleteGroup = async (groupId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/group/edit-group`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_id: groupId,
            is_deleted: true,
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("Group deleted successfully!");
        // setGroupData(prev => prev.filter(group => group.id !== deletedGroupId));
        if (typeof onGroupDelete === "function") {
          onGroupDelete(groupId); // <-- Call the callback to update parent state
        }
      } else {
        alert("Failed to delete group: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error deleting group: " + error.message);
    }
  };
  const handleReportGroup = async (groupId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/reportgroup/add-reportgroup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            group_id: String(groupId), // Ensure group_id is a string
            // reason: reason || "Other"
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("Group reported successfully!");
      } else {
        alert("Failed to report group: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("Error reporting group: " + error.message);
    }
  };
  const handleGroupCoverChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const uploaded = await uploadFiles([{ file }]);
      setEditedGroup((prev) => ({ ...prev, group_cover: uploaded[0].url }));
    } catch (err) {
      alert("Failed to upload group cover image.");
    }
    setUploading(false);
  };

  const isCurrentUserAdmin = groupMembers?.some(
    (member) =>
      member?.user?.username === currentUser?.username &&
      member?.role === "admin"
  );

  // console.log(currentUser,"currentUser")
  // console.log(groupMembers,"groupMembers")
  return (
    <div className="dashboard w-full min-h-screen  flex max-w-screen-lg mx-auto">
      <main className="flex p-2 w-full">
        {/* Main Content */}
        <main className="flex w-full">
          {/* Feeds */}
          <div className="flex-1 space-y-6">
            <div className="profile-content ">
              <div className="relative w-full ">
                {/* Cover Photo */}
                <img
                  src={matchedGroup.group_cover || profilebanner}
                  alt="Group Cover"
                  className="w-full  object-cover cover-img max-h-[300px]"
                />

                {/* Edit Button */}
                {/* <button className="edit-cover absolute top-0 right-12 bg-[#FFFFFF80] bg-opacity-50 text-[#161F28] px-4 py-2 text-sm flex items-center space-x-2 hover:bg-opacity-75 transition">
                  <img src={editcover} alt="edit" className="w-4 h-4" />
                  <span>Edit Cover</span>
                </button> */}
              </div>

              <div className=" space-y-3 profile-body relative mx-3">
                <div className="flex items-center w-full relative justify-between">
                  <div className="flex items-center relative profile-abs-content-left top-[0px]">
                    <div className="profile-dashboard profile-page-dashboard overflow-hidden relative ">
                      {/* Profile Image Upload */}
                      <label className="relative cursor-pointer">
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                        />
                        <img
                          src={matchedGroup.group_image || userimg}
                          alt="Profile"
                          className="w-full h-full object-cover"
                        />

                        <div className="absolute">
                          {/* <img
                            src={camera}
                            alt="Edit"
                            className=" text-white"
                          /> */}
                        </div>
                      </label>
                    </div>
                    <div className="feed-title edit-title pl-4 relative">
                      {isEditingGroup ? (
                        <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                          <div className="border-popup bg-white rounded-lg  relative">
                            <div className="flex justify-between">
                              <div className="logo-popup flex items-center justify-center space-x-2 ">
                                <img
                                  src={pipaanlogo}
                                  alt="Pipaan Logo"
                                  className="w-50"
                                />
                              </div>

                              {/* Close Button */}
                              <button
                                className="close-pop-x relative  text-gray-500"
                                onClick={() => setIsEditingGroup(false)}
                              >
                                {" "}
                                <img
                                  src={closecircle}
                                  alt="Pipaan Logo"
                                  className="w-10 h-10"
                                />
                              </button>
                            </div>

                            <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                              <div className="space-y-4">
                                {/* Group Name */}
                                <div className="text-center mb-5">
                                  <h2 className="font-[600] text-[#000000] text-[30px]">
                                    Edit Group
                                  </h2>
                                </div>
                                {/* Group Image Preview */}
                                <div className="mb-4 text-left">
                                  <label className="block text-[#000000] font-medium mb-2">
                                    Group Image
                                  </label>
                                  <img
                                    src={editedGroup.group_image}
                                    alt="Group"
                                    className="w-32 h-32 object-cover rounded mb-2 border"
                                  />
                                  {/* <input
                                    id="group-image"
                                    type="file"
                                        accept="image/*"

                                    value={editedGroup.group_image || ""}
                                    onChange={(e) => setEditedGroup({ ...editedGroup, group_image: e.target.value })}
                                    className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    placeholder="Enter image URL"
                                  /> */}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleGroupImageChange}
                                    className="block"
                                    disabled={uploading}
                                  />
                                </div>
                                {/* Group Cover Image Preview */}
                                <div className="mb-4 text-left">
                                  <label className="block text-[#000000] font-medium mb-2">
                                    Group Cover Image
                                  </label>
                                  <img
                                    src={
                                      editedGroup.group_cover || profilebanner
                                    }
                                    alt="Group Cover"
                                    className="w-full h-32 object-cover rounded mb-2 border"
                                  />
                                  {/* <input
                                    id="group-cover"
                                    type="text"
                                    value={editedGroup.group_cover || ""}
                                    onChange={(e) => setEditedGroup({ ...editedGroup, group_cover: e.target.value })}
                                    className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    placeholder="Enter cover image URL"
                                  /> */}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleGroupCoverChange}
                                    className="block"
                                    disabled={uploading}
                                  />
                                </div>
                                <div className="mb-4 text-left">
                                  <label
                                    htmlFor="group-name"
                                    className="block text-[#000000] font-medium mb-2"
                                  >
                                    Group Name
                                  </label>
                                  <input
                                    id="group-name"
                                    type="text"
                                    value={editedGroup.group_name}
                                    onChange={(e) =>
                                      setEditedGroup({
                                        ...editedGroup,
                                        group_name: e.target.value,
                                      })
                                    }
                                    className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    placeholder="Enter group name"
                                  />
                                </div>

                                {/* Group Description */}
                                <div className="mb-4 text-left">
                                  <label
                                    htmlFor="group-description"
                                    className="block text-[#000000] font-medium mb-2"
                                  >
                                    Group Description
                                  </label>
                                  <textarea
                                    id="group-description"
                                    value={editedGroup.description}
                                    onChange={(e) =>
                                      setEditedGroup({
                                        ...editedGroup,
                                        description: e.target.value,
                                      })
                                    }
                                    className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    placeholder="Enter group description"
                                  />
                                </div>

                                {/* Group Image URL */}
                                {/* <div className="mb-4 text-left">
                                                                    <label htmlFor="group-image" className="block text-[#000000] font-medium mb-2">
                                                                        Group Image URL
                                                                    </label>
                                                                    <input
                                                                        id="group-image"
                                                                        type="text"
                                                                        value={editedGroup.group_image || ""}
                                                                        onChange={(e) => setEditedGroup({ ...editedGroup, group_image: e.target.value })}
                                                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                        placeholder="Enter image URL"
                                                                    />
                                                                </div> */}

                                {/* Group Cover Image URL */}
                                {/* <div className="mb-4 text-left">
                                                                    <label htmlFor="group-cover" className="block text-[#000000] font-medium mb-2">
                                                                        Group Cover Image URL
                                                                    </label>
                                                                    <input
                                                                        id="group-cover"
                                                                        type="text"
                                                                        value={editedGroup.group_cover || ""}
                                                                        onChange={(e) => setEditedGroup({ ...editedGroup, group_cover: e.target.value })}
                                                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                        placeholder="Enter cover image URL"
                                                                    />
                                                                </div> */}

                                {/* Edit / Save Buttons */}
                                {isEditingGroup ? (
                                  <div className="flex gap-2 py-5">
                                    <button
                                      onClick={handleGroupUpdate}
                                      className="bg-[#095228] text-white flex items-center px-4 py-2 rounded-full"
                                    >
                                      Update
                                    </button>
                                    <button
                                      onClick={() => setIsEditingGroup(false)}
                                      className="bg-gray-300 text-black flex items-center px-4 py-2 rounded-full"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                ) : (
                                  <button
                                    onClick={() => setIsEditingGroup(true)}
                                    className="bg-[#095228] text-white flex items-center px-4 py-2 rounded"
                                  >
                                    <img
                                      src={Editicon}
                                      alt="Edit"
                                      className="mr-2"
                                    />
                                    <span>Edit</span>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <p className="font-[600] text-[#000000] text-[24px]">
                            {matchedGroup.group_name}
                          </p>
                          <p className="text-sm text-[#747474]">
                            {matchedGroup.intro}
                          </p>
                        </>
                      )}

                      <p className="flex text-sm text-[#747474]">
                        <span className="flex items-center followers-profile ml-1 cursor-pointer">
                          {/* Follower Images */}
                          {/* {matchedGroup.followerImages?.slice(0, 4).map((img, index) => (
                                                            <img
                                                                key={index}
                                                                src={img}
                                                                alt={`Follower ${index + 1}`}
                                                                className="w-6 h-6 rounded-full border-2 border-white -ml-2 first:ml-0"
                                                            />
                                                        ))} */}
                          {/* Follower Count */}
                          {/* <span className="ml-2">{matchedGroup.followers} Followers</span> */}
                        </span>
                      </p>
                    </div>
                  </div>
                  {isCurrentUserAdmin && (
                    <div className="edit-profile">
                      {isEditingGroup ? (
                        <div className="flex gap-2">
                          <button
                            onClick={handleGroupUpdate}
                            className="bg-[#095228] text-white px-4 py-2 rounded"
                          >
                            Update
                          </button>
                          <button
                            onClick={() => setIsEditingGroup(false)}
                            className="bg-gray-300 text-black px-4 py-2 rounded"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => setIsEditingGroup(true)}
                          className="bg-[#095228] text-white flex items-center px-4 py-2 rounded"
                        >
                          <img src={Editicon} alt="Edit" className="mr-2" />
                          <span>Edit</span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <div className="user-intro ">
                  <div className="user-intro-flex  my-5">
                    <div className="adminpanel-intro ">
                      <h4 className="font-semibold">Intro</h4>
                      <p>{matchedGroup.intro}</p>
                    </div>
                  </div>
                </div>
                {isCurrentUserAdmin && (
                  <div className="grp-screen-cta flex items-center gap-2 py-2 rounded-lg">
                    {/* Search Input */}
                    <div className="flex items-center border border-gray-300 bg-white rounded-full px-3 py-2 find">
                      <svg
                        className="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 21l-4.35-4.35"
                        ></path>
                        <circle cx="10.5" cy="10.5" r="7.5"></circle>
                      </svg>
                      <input
                        type="text"
                        placeholder="Add Members"
                        className="ml-2 text-gray-500 outline-none bg-transparent"
                      />
                      <div className="hidden md:block">
                        <button
                          onClick={() => setShowModal(true)}
                          className=" flex items-center gap-2 bg-green-800 text-white px-4 py-1 mx-1 rounded-full add "
                        >
                          <img src={Add} alt="Edit" className=" text-white" />
                          <span className="text-sm text-[#fff]">
                            Add Memberr
                          </span>
                        </button>
                        {showModal && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white p-6 rounded-lg w-96">
                              <h2 className="text-lg font-semibold mb-4">
                                Add Member
                              </h2>
                              <input
                                type="text"
                                placeholder="Search user"
                                className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
                                value={modalSearch}
                                onChange={handleModalSearch}
                              />
                              <div className="max-h-60 overflow-y-auto mb-4">
                                {modalLoading ? (
                                  <p>Loading...</p>
                                ) : modalSearch.trim() &&
                                  modalResults.length === 0 ? (
                                  <p>No results found.</p>
                                ) : (
                                  modalResults.map((user) => (
                                    <div
                                      key={user.id}
                                      className={`flex items-center gap-3 p-2 rounded hover:bg-gray-100 cursor-pointer ${
                                        selectedUserId === user.id
                                          ? "bg-green-50 border-2 border-green-600"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        setSelectedUserId(String(user.id))
                                      }
                                    >
                                      <img
                                        src={user.profile_picture_url || userimg}
                                        alt={user.username}
                                        className="w-10 h-10 rounded-full"
                                      />
                                      <div>
                                        <p className="font-medium">
                                          {user.first_name} {user.last_name}
                                        </p>
                                        <p className="text-sm text-gray-500">
                                          @{user.username}
                                        </p>
                                      </div>
                                    </div>
                                  ))
                                )}
                              </div>
                              <div className="flex justify-end gap-2">
                                <button
                                  onClick={() => {
                                    setShowModal(false);
                                    setModalSearch("");
                                    setModalResults([]);
                                    setSelectedUserId(null);
                                  }}
                                  className="px-3 py-1 bg-gray-400 text-white rounded"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleAddMember}
                                  className="px-3 py-1 bg-green-600 text-white rounded"
                                  disabled={!selectedUserId}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex items-center ctas">
                      {/* Buttons */}
                      {/* <button className=" flex items-center gap-2 bg-green-800 text-white px-4 py-1 mx-1 rounded-full add">
                                                    <img src={Add} alt="Edit" className=" text-white" /><span className="text-sm text-[#fff] hidden md:block">Add Member+</span>
                                                </button> */}

                      {/* <button className="flex items-center gap-2 bg-green-800 text-white px-4 py-[10px] mx-1 rounded-full invite">
                                            <img src={Attach} alt="Edit" className=" text-white" /><span className="text-sm text-[#fff] hidden md:block"> Invite to Group Via Link</span>
                                        </button> */}

                      <button
                        className="flex items-center gap-2 bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] px-4 py-[10px] mx-1 rounded-full"
                        onClick={() => {
                          if (groupMembers.length === 0) {
                            handleDeleteGroup(matchedGroup?.id); // auto-delete if no members
                          } else {
                            setShowDeleteConfirm(true); // show modal if members exist
                          }
                        }}
                      >
                        <img
                          src={Trash}
                          alt="Delete"
                          className="text-[#BE1F2E]"
                        />
                        <span className="text-sm text-[#BE1F2E] hidden md:block">
                          Delete
                        </span>
                      </button>
                      {showDeleteConfirm && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]">
                          <div className="bg-white rounded-lg p-8 shadow-lg max-w-sm w-full text-center">
                            <h2 className="text-lg font-bold mb-4 text-[#BE1F2E]">
                              Delete Group
                            </h2>
                            <p className="mb-6 text-gray-700">
                              Are you sure you want to delete this group? This
                              action cannot be undone.
                            </p>
                            <div className="flex justify-center gap-4">
                              <button
                                className="bg-gray-300 text-black px-4 py-2 rounded"
                                onClick={() => setShowDeleteConfirm(false)}
                              >
                                Cancel
                              </button>
                              <button
                                className="bg-[#BE1F2E] text-white px-4 py-2 rounded"
                                onClick={() => {
                                  setShowDeleteConfirm(false);
                                  handleDeleteGroup(matchedGroup.id);
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <button
                        className="flex items-center gap-2 bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] px-4 py-[10px] mx-1 rounded-full"
                        onClick={() => setShowReportModal(true)}
                      >
                        <img src={Danger} alt="Report" className="text-white" />
                        <span className="text-sm text-[#BE1F2E] hidden md:block">
                          Report
                        </span>
                      </button>
                      {showReportModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]">
                          <div className="bg-white rounded-lg p-8 shadow-lg max-w-sm w-full text-center">
                            <h2 className="text-lg font-bold mb-4 text-[#BE1F2E]">
                              Report Group
                            </h2>
                            <p className="mb-4 text-gray-700">
                              Please select a reason for reporting this group:
                            </p>
                            <select
                              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
                              value={reportReason}
                              onChange={(e) => setReportReason(e.target.value)}
                            >
                              <option value="">Select reason</option>
                              {reportReasons.map((reason) => (
                                <option key={reason} value={reason}>
                                  {reason}
                                </option>
                              ))}
                            </select>
                            <div className="flex justify-center gap-4">
                              <button
                                className="bg-gray-300 text-black px-4 py-2 rounded"
                                onClick={() => {
                                  setShowReportModal(false);
                                  setReportReason("");
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                className="bg-[#BE1F2E] text-white px-4 py-2 rounded"
                                disabled={!reportReason}
                                onClick={async () => {
                                  await handleReportGroup(
                                    matchedGroup.id,
                                    reportReason
                                  );
                                  setShowReportModal(false);
                                  setReportReason("");
                                }}
                              >
                                Report
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 md:hidden">
              <div className="flex w-full">
                <img
                  src={userimg}
                  alt="User"
                  className="w-15 h-15 rounded-full"
                />
                <div className="pl-4 w-full">
                  <div className="flex items-center justify-between">
                    <p className="titlesemibold pb-1 pr-5">Marketing Group</p>
                  </div>
                  <p className="text-[12px] text-[#747474] pb-1">@prvnk_sky</p>
                  {/* <p className="members">764 Followers <span className="text-[#D9D9D9] px-1">|</span> <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span></p> */}
                </div>
              </div>
              <div className="flex follow-unfollow-cta justify-end w-full">
                <button className="follow-cta my-2">Add Member</button>
                {/* <button className="follow-cta-block my-2">Block</button> */}
              </div>
            </div>
            <div className="grp-admin-count mx-3">
              <p>
                {matchedGroup.acceptedMembersCount} Group Members |{" "}
                {matchedGroup.adminCounts} Admins
              </p>{" "}
            </div>
            <div className="feed-tabs profile-page-feeds w-full mx-3 text-center lg:text-left">
              <div className="flex relative w-full ">
                <div className="fasearch">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                </div>
                <input
                  type="text"
                  placeholder="Find Group member"
                  className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                  value={memberSearch}
                  onChange={handleMemberSearch}
                />
              </div>

              <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
                {groupMembers.map((member) => (
                  <div
                    key={member.id}
                    className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                  >
                    <div className="flex w-full">
                      <img
                        src={member.user.profile_picture_url || userimg}
                        alt={member.user.first_name}
                        className="w-15 h-15 rounded-full"
                      />
                      <div className="pl-4 w-full md:flex align-items justify-between">
                        <div className="w-full text-left">
                          <p className="titlesemibold pb-1 pr-5">
                            {member.user.first_name} {member.user.last_name}
                            {/* Add admin badge here */}
                            {member.role === "admin" && (
                              <span className="ml-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full font-semibold align-middle">
                                Admin
                              </span>
                            )}
                          </p>{" "}
                          <p className="text-[12px] text-[#747474] pb-1">
                            @{member.user.username}
                          </p>
                          <p className="text-[12px] text-[#747474] pb-1">
                            {member.user.followersCount} Followers
                          </p>
                          <p className="members">
                            {/* Role: {member.role} | Status: {member.status} */}
                          </p>
                        </div>


                        <div className="w-full relative btn-drp-userpage">
  <button
    onClick={() =>
      setOpenDropdownId(openDropdownId === member.id ? null : member.id)
    }
    className="flex absolute right-0 justify-center w-8 h-8 rounded-full hover:bg-gray-100 menu-btn-userpage"
  >
    <MoreHorizontal size={18} />
  </button>

  {openDropdownId === member?.id && (
    <div className="absolute right-8 mt-2 w-40 bg-green-50 rounded-md shadow-lg z-10">
      <div className="py-0 text-center text-sm text-black">
        {/* ✅ Only admins can mark others as admin or remove */}
        {isCurrentUserAdmin && member.user.id !== currentUser.id && (
          <>
            <div
              className="px-4 py-2 hover:bg-green-100 cursor-pointer"
              onClick={() => handleMakeAdmin(member)}
            >
              Mark As Group Admin
            </div>
            <hr className="my-1 border-green-200" />

            <div
              className="px-4 py-2 hover:bg-green-100 cursor-pointer"
              onClick={() => handleRemoveMember(member)}
            >
              Remove
            </div>
            <hr className="my-1 border-green-200" />
          </>
        )}

        {/* ✅ Any user can leave their own group */}
        {member.user.id === currentUser.id && (
          <>
            <div
              className="px-4 py-2 hover:bg-green-100 cursor-pointer"
              onClick={handleLeaveGroup}
            >
              Leave Group
            </div>
            <hr className="my-1 border-green-200" />
          </>
        )}
      </div>
    </div>
  )}
</div>


                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </main>
    </div>
  );
};

export default Adminpanel;
